import {
    Alert,
    Box,
    Button,
    Grid,
    IconButton,
    Paper,
    Tooltip,
    Typography,
} from '@mui/material';
import FHIRHumanName from './fhirHumanName';
import {
    AsyncAutoCompleteWithTopLabel,
    DateSelectorWithTopLabelComponent,
    SelectWithTopLabelComponent,
    TextFieldWithTopLabelComponent,
} from '../uiComponent/fhirComponentUi';
import { createRef, memo, useEffect, useRef, useState } from 'react';
import { humanGenderOptionsList } from '../../../data/fhirHumanNameData';
import { useDispatch, useSelector } from 'react-redux';
import { setToolbarButtons } from '../../../redux/features/toolbarSlice';
import { toolbarConstants } from '../../../constants/toolbar/toolbarConstants';
import _, { isEmpty } from 'lodash';
import { setProgress } from '../../../redux/features/progressSlice';
import { setEditMode } from '../../../redux/features/editModeSlice';
import { generateNotifications } from '../../reusableLogic';
import { ehrAPIBaseService, ehrAPIService } from '../../../http-common';
import { useSnackbar } from 'notistack';
import { getIdentifierFhirStructure } from '../utils';
import dayjs from 'dayjs';
import FHIRTelecom from './fhirTelecom';
import { containCrop } from 'react-image-crop';
import { forwardRef } from 'react';
import { useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import { Add, Delete, Person, PersonOff } from '@mui/icons-material';
import CustomConfirmDialog from '../../customConfirmationDialog';
import { useMainFrameState } from '../../MainUIFrame/MainFrame';
import FHIRAddress from './fhirAddress';

const RelationUI = memo(props => {
    const { data, index } = props;
    return (
        <>
            <Grid container item xs={8} spacing={1}>
                <Grid item sm={4}>
                    <AsyncAutoCompleteWithTopLabel
                        // id={id}
                        disabled={data?.id}
                        // key={data?.relatedTo?.code}
                        onChange={e => props?.handleOnChange1(e, index)}
                        placeholder="Search Patient"
                        name="relatedTo"
                        value={data?.relatedTo}
                        label="Related To"
                        urlType="fhir"
                        url="/fhir/search/Patient?name:contains="
                        disableClearable
                        ref={props?.relatedToRef}
                        validation={{
                            required: true /*data?.relationType || data?.relatedTo,*/,
                        }}
                        bundlingFunction={list => {
                            const optionsList = [];
                            for (const item of list) {
                                if (
                                    !props?.relatedToIdList?.includes(
                                        `${item?.resource?.resourceType}/${item?.resource?.id}`
                                    )
                                ) {
                                    const obj = {};
                                    obj.code = `${item?.resource?.resourceType}/${item?.resource?.id}`;
                                    obj.display =
                                        item?.resource?.name?.[0]?.text;
                                    obj.rawData = item?.resource;
                                    optionsList.push(obj);
                                }
                            }
                            return optionsList;
                        }}
                    />
                </Grid>
                <Grid item sm={1} mt={3}>
                    <Typography textAlign={'center'} fontSize={'18px'}>
                        - is -
                    </Typography>
                </Grid>
                <Grid item sm={4}>
                    <SelectWithTopLabelComponent
                        // id={id}
                        disabled={data?.raw?.active === false ? true : false}
                        // key={data?.relationType}
                        onChange={e => props?.handleOnChange1(e, index)}
                        name="relationType"
                        value={data?.relationType}
                        // label="Relation Type"
                        label="&nbsp;Relation"
                        optionsList={props?.relationshipOptionsList}
                        ref={props?.relationRef}
                        validation={{
                            required: true /*data?.relationType || data?.relatedTo,*/,
                        }}
                    />
                </Grid>
                <Grid item sm={3} mt={2} sx={{ display: 'flex' }}>
                    {data?.id ? (
                        <Tooltip
                            title={
                                data?.raw?.active
                                    ? 'Disable Related Person'
                                    : 'Enable Related Person'
                            }
                        >
                            {data?.raw?.active ? (
                                <IconButton
                                    color="primary"
                                    onClick={() =>
                                        props?.handleRelatedPersonStatus(
                                            index,
                                            'disable'
                                        )
                                    }
                                >
                                    <Person />
                                </IconButton>
                            ) : (
                                <IconButton
                                    onClick={() =>
                                        props?.handleRelatedPersonStatus(
                                            index,
                                            'enable'
                                        )
                                    }
                                >
                                    <PersonOff />
                                </IconButton>
                            )}
                        </Tooltip>
                    ) : (
                        props?.relations?.length > 1 && (
                            <Tooltip title="delete">
                                <IconButton
                                    onClick={() =>
                                        props?.handleRelatedPersonStatus(
                                            index,
                                            'delete'
                                        )
                                    }
                                >
                                    <Delete />
                                </IconButton>
                            </Tooltip>
                        )
                    )}
                    {(Number(index) < 4 && Number(index)) ===
                        props?.relations?.length - 1 && (
                        <Tooltip title="Add New Relation">
                            <IconButton
                                disabled={
                                    !(data?.relationType && data?.relatedTo)
                                }
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    props?.setRelations([
                                        ...props?.relations,
                                        props?.emptyRelationData,
                                    ]);
                                }}
                            >
                                <Add />
                            </IconButton>
                        </Tooltip>
                    )}
                </Grid>
            </Grid>
        </>
    );
});

const FHIRContact = forwardRef((props, ref) => {
    const data = props?.relatedpersonObject;
    const birthDateRef = useRef();
    const genderRef = useRef();
    const addressRef = useRef();
    const ssnRef = useRef();
    const humanNameRef = useRef();
    const availableDaysRef = useRef();
    const availableTimingsRef = useRef();
    // const relationTypeRef = useRef();
    // const relatedPersonRef = useRef();
    const telecomRef = useRef();
    const selectedVersion = useSelector(
        state => state.changeVersion.selectedVersion
    );

    const navigate = useNavigate();

    const [contactState, setContactState] = useState({});
    const emptyRelationData = {
        relationType: '',
        relatedTo: null,
        // relationTypeRef: useRef(null),
        // relatedToRef: useRef(null),
    };
    const [isEdit, setIsEdit] = useState(props?.isEdit);
    const relationTypeRef = useRef(
        Array.from(Array(5).keys()).map(() => createRef())
    );
    const relatedToRef = useRef(
        Array.from(Array(5).keys()).map(() => createRef())
    );
    const [relations, setRelations] = useState([emptyRelationData]);
    const [relatedToIdList, setRelatedToIdList] = useState([]);

    useEffect(() => {
        setIsEdit(props?.isEdit);
    }, [props?.isEdit]);

    useEffect(() => {
        // if (data?.link) {
        //     fetchData(data?.link);
        //     // fetchData(item?.target?.reference);
        // }
        console.log('it is running again and again');
        if (data?.id) {
            let telecom = data?.telecom?.map(item => {
                let tempItem = { ...item };
                if (tempItem?.system === 'phone') {
                    if (tempItem?.use === 'home') {
                        tempItem.use = 'mobile';
                    } else {
                        tempItem.use = 'home';
                    }
                    tempItem.value = formatPhoneNumber(tempItem?.value) || '';
                }
                return tempItem;
            });
            setContactState({
                birthDate: data?.birthDate,
                gender: data?.gender,
                name: data?.name?.[0] || [],
                telecom: telecom || [],
            });
        }
        if (props?.relations?.length > 0) {
            console.log('relation updating by props again and again');
            setRelations([...props?.relations]);
        }
    }, [props]);

    const formatPhoneNumber = phone => {
        if (phone?.length === 10) {
            return phone;
        } else if (phone?.length > 10) {
            let fullLength = phone?.length;
            let extraLength = fullLength - 10;
            // now exact length
            return phone?.slice(extraLength);
        }
    };

    useImperativeHandle(ref, () => ({
        save: () => handleSave(),
    }));

    useEffect(() => {
        const tempIds = [];
        // debugger;
        for (let item of relations) {
            if (item?.relatedTo?.code || item?.relatedTo?.reference) {
                tempIds?.push(
                    item?.relatedTo?.code || item?.relatedTo?.reference
                );
            }
        }
        setRelatedToIdList(tempIds);
    }, [relations]);

    const [currentAddressObject, setCurrentAddressObject] = useState({
        official: !_.isUndefined(
            data?.address?.[_.findIndex(data?.address, o => o?.use === 'home')]
        )
            ? data?.address?.[
                  _.findIndex(data?.address, o => o?.use === 'home')
              ]
            : {
                  use: 'home',
                  type: 'postal',
                  text: '',
                  line: [],
                  city: '',
                  district: '',
                  state: '',
                  postalCode: '',
                  country: '',
              },
        billing: !_.isUndefined(
            data?.address?.[_.findIndex(data?.address, o => o?.use === 'work')]
        )
            ? data?.address?.[
                  _.findIndex(data?.address, o => o?.use === 'work')
              ]
            : {
                  use: 'work',
                  type: 'postal',
                  text: '',
                  line: [],
                  city: '',
                  district: '',
                  state: '',
                  postalCode: '',
                  country: '',
              },
    });

    useEffect(() => {
        setCurrentAddressObject({
            official: !_.isUndefined(
                data?.address?.[
                    _.findIndex(data?.address, o => o?.use === 'home')
                ]
            )
                ? data?.address?.[
                      _.findIndex(data?.address, o => o?.use === 'home')
                  ]
                : {
                      use: 'home',
                      type: 'postal',
                      text: '',
                      line: [],
                      city: '',
                      district: '',
                      state: '',
                      postalCode: '',
                      country: '',
                  },
            billing: !_.isUndefined(
                data?.address?.[
                    _.findIndex(data?.address, o => o?.use === 'work')
                ]
            )
                ? data?.address?.[
                      _.findIndex(data?.address, o => o?.use === 'work')
                  ]
                : {
                      use: 'work',
                      type: 'postal',
                      text: '',
                      line: [],
                      city: '',
                      district: '',
                      state: '',
                      postalCode: '',
                      country: '',
                  },
        });
    }, [data?.address]);

    const reduxDispatch = useDispatch();

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const relationshipOptionsList = [
        // // {
        // //   code: 'self',
        // //   display: 'Self',
        // // },
        {
            code: 'spouse',
            display: 'Spouse',
        },
        {
            code: 'child',
            display: 'Child',
        },
        {
            code: 'parent',
            display: 'Parent',
        },
        {
            code: 'Common Law Spouse',
            display: 'Common Law Spouse',
        },
        {
            code: 'other',
            display: 'Other',
        },
        {
            code: 'Injured Party',
            display: 'Injured Party',
        },
    ];

    // const [ customRelaitonList, setCustomRelationList ] = useState(relationshipOptionsList);

    // useEffect(() => {
    //   setCustomRelationList([{code:'Add Relation', display:'Add Relation'}, ...customRelaitonList]);
    // },[])

    const daysOfWeekDisplayList = [
        { id: 1, display: 'Monday', code: 'Mon' },
        { id: 2, display: 'Tuesday', code: 'Tue' },
        { id: 3, display: 'Wednesday', code: 'Wed' },
        { id: 4, display: 'Thursday', code: 'Thu' },
        { id: 5, display: 'Friday', code: 'Fri' },
        { id: 6, display: 'Saturday', code: 'Sat' },
        { id: 7, display: 'Sunday', code: 'Sun' },
    ];

    const birthDateValidationObject = {
        name: 'birthDate',
        value: contactState?.birthDate,
        label: 'Birth Date',
        format: 'MM/dd/yyyy',
        // format: 'dd/MM/yyyy',
        ref: birthDateRef,
        // width: '90%',
        validation: {
            required: true,
        },
    };

    const genderValidationObject = {
        name: 'gender',
        value: contactState?.gender,
        label: 'Gender',
        ref: genderRef,
        // width: '90%',
        optionsList: humanGenderOptionsList,
        validation: {
            required: true,
        },
    };

    const ssnValidationObject = {
        name: 'ssn',
        value: contactState?.ssn,
        ref: ssnRef,
        label: 'SSN',
        validation: {
            required: false,
            min: 9,
            max: 9,
        },
        mask: '999-99-9999',
        maxLength: 9,
    };

    // const [customRelationType, setCustomRelationType] = useState('');
    // const custormRelationTypeRef = useRef();

    // const relationTypeValidationObjectCustom = {
    //   name: 'relationType',
    //   label: 'Relation Type',
    //   validation: {
    //     required: true,
    //   },
    //   ref: custormRelationTypeRef,
    //   value: customRelationType

    // }

    // const relationTypeValidationObject = {
    //     name: 'relationType',
    //     value: contactState?.relationType,
    //     label: 'Relation Type',
    //     ref: relationTypeRef,
    //     // width: '90%',
    //     optionsList: relationshipOptionsList,
    //     validation: {
    //         required: contactState?.relationType || contactState?.relatedTo,
    //     },
    // };

    // const relatedToValidationObject = {
    //     name: 'relatedTo',
    //     value: contactState?.relatedTo,
    //     label: 'Related To',
    //     ref: relatedPersonRef,
    //     urlType: 'fhir',
    //     url: '/fhir/search/Patient?name:contains=',
    //     validation: {
    //         required: contactState?.relationType || contactState?.relatedTo,
    //     },
    // };

    const primaryPhoneValidationObject = {
        name: 'primaryPhone',
        value: contactState?.primaryPhone,
        label: 'Primary Phone',
        validation: {
            required: false,
            min: 10,
            max: 10,
        },
        mask: '(999) 999-9999',
        maxLength: 10,
    };

    const secondaryPhoneValidationObject = {
        name: 'secondaryPhone',
        value: contactState?.secondaryPhone,
        label: 'Secondary Phone',
        validation: {
            required: false,
            min: 10,
            max: 10,
        },
        mask: '(999) 999-9999',
        maxLength: 10,
    };

    const emailValidationObject = {
        name: 'email',
        value: contactState?.email,

        label: 'Email',
    };

    const availableDaysValidationObject = {
        name: 'availableDays',
        value: contactState?.availableDays || [],
        label: 'Available Days',
        ref: availableDaysRef,
        // width: '90%',
        optionsList: daysOfWeekDisplayList,
        checkBoxSelection: true,
        multiple: true,
        validation: {
            required: true,
        },
    };

    const availableTimingsValidationObject = {
        name: 'availableTimings',
        value: contactState?.availableTimings,
        label: 'Available Timings',
        ref: availableTimingsRef,
        // width: '90%',
        optionsList: humanGenderOptionsList,
        validation: {
            required: true,
        },
    };

    const createPerson = async (relatedPersonId, fhirPersonId) => {
        let nameObj = humanNameRef?.current?.handleOnUpdate();
        let addressList = addressRef?.current?.handleOnUpdate();
        let telecomArray = telecomRef?.current?.handleOnUpdate();

        telecomArray?.forEach(item => {
            if (item?.system === 'phone') {
                if (item?.use === 'home') {
                    item.use = 'mobile';
                    item.value =
                        selectedVersion == 'IN' ? '+91' : '+1' + item?.value;
                } else {
                    item.use = 'home';
                    item.rank = 1;
                }
            }
        });
        // addressList?.valid &&

        delete addressList.valid;
        delete nameObj.valid;
        delete nameObj.isStateChanged;

        delete addressList.isStateChanged;
        delete telecomArray.valid;
        delete telecomArray.isStateChanged;

        let param = {
            resourceType: 'Person',
            // "identifier": [
            // {
            // "system": "http://example.com/identifiers",
            // "value": "12345"
            // }
            // ],
            name: [nameObj],
            telecom: telecomArray,
            gender: contactState?.gender,
            birthDate: dayjs(contactState?.birthDate).format('YYYY-MM-DD'),
            active: true,
        };
        if (fhirPersonId) {
            param.meta = data?.meta;
            if (data?.extension) param.extension = data?.extension;
            if (data?.identifier) param.identifier = data?.identifier;
        }
        param.address = addressList;
        if (fhirPersonId) {
            param.id = fhirPersonId;
        }
        if (relatedPersonId?.length > 0) {
            const link = [];
            for (const item of relatedPersonId) {
                const obj = {
                    target: {
                        reference: `RelatedPerson/${item}`,
                    },
                    assurance: 'level1',
                };
                link.push(obj);
            }
            param.link = link;

            // param.address =
            //     relatedPersonValid?.value?.rawData?.address || data?.address;
        }
        let type = '';
        let message = '';
        let description = '';
        try {
            reduxDispatch(setProgress(true));

            let response;
            if (fhirPersonId) {
                response = await ehrAPIService.put(`updateResource`, param);
            } else {
                param.meta = {
                    tag: [
                        {
                            system: 'http://enliv.com/user/user-resource-type',
                            code: 'contact',
                            display: 'Contact',
                        },
                    ],
                };
                response = ehrAPIService.post(`createResource`, param);
            }

            type = 'success';
            message = `Person ${
                fhirPersonId ? 'Updated' : 'Created'
            } Successfully`;
            description = `Person ${
                fhirPersonId ? 'Updated' : 'Created'
            } Successfully`;
            // reduxDispatch(setEditMode(false));
        } catch (e) {
            console.log('catch block');
            console.error(e);
            type = 'error';
            message = 'Something went wrong, please try again!';
            description = `Something went wrong, please try again!`;
        } finally {
            reduxDispatch(setProgress(false));
            generateNotifications({
                title: message,
                descriptions: description,
                enqueueSnackbar,
                closeSnackbar,
                reduxDispatch,
            });
            navigate('/contacts');
        }
    };

    const handleOnChange1 = (e, index) => {
        const { name, value } = e.target;

        const updatedRelations = [...relations];

        const updatedRelation = { ...updatedRelations[index] };

        updatedRelation[name] = value;

        updatedRelations[index] = updatedRelation;

        setRelations(updatedRelations);
    };

    const { isDark } = useMainFrameState();

    const confirmation = CustomConfirmDialog;

    const handleRelatedPersonStatus = (index, operaitonType) => {
        const currentRecord = relations[index];
        const tempRecord = [...relations];
        let message;
        let description;
        if (operaitonType !== 'delete') {
            if (currentRecord?.id) {
                const options = {
                    message: `Do you really want to ${
                        currentRecord?.raw?.active ? 'disable' : 'enable'
                    } relation type "${currentRecord?.relationType}" with "${
                        currentRecord?.relatedTo?.display
                    }"`,
                    isDark,
                };
                confirmation(options)
                    .then(() => {
                        const deleteRelatedPerson = async () => {
                            reduxDispatch(setProgress(true));
                            try {
                                let param = { ...currentRecord?.raw };
                                param.active = !currentRecord?.raw?.active;
                                let response = await ehrAPIService.put(
                                    `updateResource`,
                                    param
                                );
                                console.log(response);
                                message = 'success';
                                description = `Related person ${
                                    currentRecord?.raw?.active
                                        ? 'disabled'
                                        : 'enabled'
                                } successfully.`;
                                props?.setFetchRelationData(
                                    props?.fetchRelationData + 1
                                );
                            } catch (e) {
                                message = 'error';
                                description = `Related person deletion failed.`;
                            } finally {
                                reduxDispatch(setProgress(false));
                                generateNotifications({
                                    title: message,
                                    descriptions: description,
                                    enqueueSnackbar,
                                    closeSnackbar,
                                    reduxDispatch,
                                });
                            }
                        };
                        deleteRelatedPerson();
                    })
                    .catch(() => {
                        console.log('user cancel operaiton');
                    });
            }
        } else {
            tempRecord?.splice(index, 1);
            setRelations(tempRecord);
        }
    };

    const handleOnChange = event => {
        // debugger;
        const { name, value } = event?.target;
        setContactState({
            ...contactState,
            [name]: value,
        });
    };

    useEffect(() => {
        console.log('relations changing again and again', relations);
    }, [relations]);

    const handleSave = async () => {
        let nameObj = humanNameRef?.current?.handleOnUpdate();
        let telecomArray = telecomRef?.current?.handleOnUpdate();
        const birthDateValid = birthDateRef?.current?.onValidate();
        const genderValid = genderRef?.current?.onValidate();
        const ssnValid = ssnRef?.current?.onValidate();
        let addressList = addressRef?.current?.handleOnUpdate();

        // for (let relation of relations) {
        //     debugger;
        //     const relationTypeValid =
        //         relation?.relationTypeRef?.current?.onValidate();
        //     const relatedToValid =
        //         relation?.relatedToRef?.current?.onValidate();
        //     if (relationTypeValid?.valid && relatedToValid?.isValid) {
        //         continue;
        //     } else {
        //         return;
        //     }
        // }
        debugger;

        for (let i = 0; i < relations?.length; i++) {
            const relationTypeValid =
                relationTypeRef?.current?.[i]?.current?.onValidate();
            const relatedToValid =
                relatedToRef?.current?.[i]?.current?.onValidate();
            if (relationTypeValid?.valid && relatedToValid?.isValid) {
                continue;
            } else {
                return;
            }
        }

        let relatedPersonId = [];

        if (
            nameObj?.valid &&
            addressList.valid &&
            telecomArray?.valid &&
            birthDateValid?.valid &&
            genderValid?.valid
        ) {
            delete nameObj.valid;
            delete telecomArray.valid;
            delete birthDateValid?.valid;

            delete nameObj.isStateChanged;
            delete telecomArray.isStateChanged;

            const ssn = getIdentifierFhirStructure(
                'http://hl7.org/fhir/sid/us-ssn',
                'SS',
                ssnValid?.value,
                contactState?.ssn
            );

            let param = {};
            // param.name = [nameObj];
            // param.gender = genderValid?.value;
            // param.birthDate = dayjs(birthDateValid?.value).format('YYYY-MM-DD');
            param.resourceType = 'RelatedPerson';
            // param.identifier = [ssn];
            // param.telecom = telecomArray;

            console.log(`relatedpersonObject`, param);
            let type = '';
            let message = '';
            let description = '';

            if (relations?.[0]?.relationType !== '') {
                for (const [index, item] of relations.entries()) {
                    // param.address = item?.relatedTo?.rawData?.address;
                    param.patient = {
                        reference: !_.isUndefined(item?.relatedTo?.code)
                            ? item?.relatedTo?.code?.includes('Patient')
                                ? `${item?.relatedTo?.code}`
                                : `Patient/${item?.relatedTo?.code}`
                            : item?.relatedTo?.reference,
                        type: 'Patient',
                        display: item?.relatedTo?.display,
                    };
                    param.relationship = [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/v3-RoleCode',
                                    code: item?.relationType,
                                    display: _.capitalize(item?.relationType),
                                },
                            ],
                        },
                    ];
                    param.active = item?.id ? item?.raw?.active : true;
                    try {
                        reduxDispatch(setProgress(true));
                        let response;
                        if (item?.id) {
                            relatedPersonId.push(item?.id);
                            if (
                                item?.raw?.active &&
                                item?.relationType !==
                                    props?.relations?.[index]?.relationType
                            ) {
                                param.id = item?.id;
                                response = await ehrAPIService.put(
                                    `updateResource`,
                                    param
                                );
                            }
                        } else {
                            response = await ehrAPIService.post(
                                `createResource`,
                                param
                            );
                            relatedPersonId.push(response?.data?.id);
                        }

                        // relatedPersonId.push(response?.data?.id);
                        type = 'success';
                        message = `Related Person ${
                            item?.id ? 'Updated' : 'Created'
                        } Successfully`;
                        description = `Related Person ${
                            item?.id ? 'Updated' : 'Created'
                        } Successfully`;
                    } catch (e) {
                        console.log('catch block');
                        console.error(e);
                        type = 'error';
                        message = `Something went wrong, while ${
                            item?.id ? 'updating' : 'creating'
                        } related person!`;
                        description = `Something went wrong, while ${
                            item?.id ? 'updating' : 'creating'
                        } related person, please try again!`;
                        generateNotifications({
                            title: message,
                            descriptions: description,
                            enqueueSnackbar,
                            closeSnackbar,
                            reduxDispatch,
                        });
                    } finally {
                        reduxDispatch(setProgress(false));
                        // generateNotifications({
                        //     title: message,
                        //     descriptions: description,
                        //     enqueueSnackbar,
                        //     closeSnackbar,
                        //     reduxDispatch,
                        // });
                    }
                }
            }
        } else {
            return;
        }
        if (data?.id) {
            createPerson(relatedPersonId, data?.id);
        } else {
            createPerson(relatedPersonId);
        }
    };

    return (
        <>
            <Box p={2}>
                <Paper
                    elevation={2}
                    sx={{ padding: '20px', marginBottom: '30px' }}
                >
                    <Grid container>
                        <Grid item xs={8}>
                            <Grid item xs={12}>
                                <FHIRHumanName
                                    fullWidth
                                    customTitle={
                                        <Typography
                                            sx={{ fontWeight: '500' }}
                                            color={'primary'}
                                            mb={2}
                                        >
                                            Personal Info
                                        </Typography>
                                    }
                                    stateChangeActive={false}
                                    ref={humanNameRef}
                                    // isCreate={_.isUndefined(patientState?.id)}
                                    isEdit={true}
                                    nameObject={contactState?.name}
                                />
                            </Grid>

                            <Grid item xs={12} container spacing={1}>
                                <Grid item sm={4}>
                                    <DateSelectorWithTopLabelComponent
                                        onChange={handleOnChange}
                                        {...birthDateValidationObject}
                                    />
                                </Grid>
                                <Grid item sm={4}>
                                    <SelectWithTopLabelComponent
                                        key={contactState?.gender}
                                        onChange={handleOnChange}
                                        {...genderValidationObject}
                                    />
                                </Grid>
                                {/* <Grid item sm={4}>
                                    <TextFieldWithTopLabelComponent
                                        onChange={handleOnChange}
                                        {...ssnValidationObject}
                                    />
                                </Grid> */}
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
                <Paper
                    elevation={2}
                    sx={{ padding: '20px', marginBottom: '30px' }}
                >
                    <Typography
                        sx={{ fontWeight: '500' }}
                        color={'primary'}
                        mb={2}
                    >
                        Relationship Details
                    </Typography>
                    <Grid container spacing={2}>
                        {/* {
                            relations?.length > 0{

                            }
                        } */}
                        {relations?.map((relation, index) => (
                            <RelationUI
                                data={relation}
                                key={relation?.relatedTo?.code}
                                index={index}
                                relationRef={relationTypeRef?.current?.[index]}
                                relatedToRef={relatedToRef?.current?.[index]}
                                handleOnChange1={handleOnChange1}
                                relationshipOptionsList={
                                    relationshipOptionsList
                                }
                                relatedToIdList={relatedToIdList}
                                handleRelatedPersonStatus={
                                    handleRelatedPersonStatus
                                }
                                relations={relations}
                                setRelations={setRelations}
                                emptyRelationData={emptyRelationData}
                            />
                        ))}

                        {/* <Grid container item xs={8} spacing={2}>
                            <Grid item sm={4}>
                                <SelectWithTopLabelComponent
                                    key={contactState?.relationType}
                                    onChange={handleOnChange}
                                    {...relationTypeValidationObject}
                                />
                            </Grid>
                            <Grid item sm={4}>
                                <AsyncAutoCompleteWithTopLabel
                                    key={contactState?.relatedTo?.display}
                                    onChange={handleOnChange}
                                    {...relatedToValidationObject}
                                    bundlingFunction={list => {
                                        const optionsList = [];
                                        for (const item of list) {
                                            const obj = {};
                                            obj.code = `${item?.resource?.resourceType}/${item?.resource?.id}`;
                                            obj.display =
                                                item?.resource?.name?.[0]?.text;
                                            obj.rawData = item?.resource;
                                            optionsList.push(obj);
                                        }
                                        return optionsList;
                                    }}
                                />
                            </Grid>
                        </Grid> */}
                    </Grid>
                    {relations?.length === 5 && (
                        <Grid item xs={6} mt={2}>
                            <Alert
                                icon={false}
                                severity="warning"
                                sx={{ width: '88%' }}
                            >
                                *You can add five relations at max.
                            </Alert>
                        </Grid>
                        // <Typography mt={2} color={'#d32f2f'}>*You can not add more than five relations</Typography>
                    )}
                </Paper>
                <Paper
                    elevation={2}
                    sx={{ padding: '20px', marginBottom: '30px' }}
                >
                    {/* <Typography
                        sx={{ fontWeight: '500' }}
                        color={'primary'}
                        mb={2}
                    >
                        Contact Details
                    </Typography> */}
                    <Grid container>
                        <Grid container item xs={8}>
                            <FHIRTelecom
                                fullWidth
                                emailRequired={false}
                                customTitle={
                                    <Typography
                                        sx={{ fontWeight: '500' }}
                                        color={'primary'}
                                        mb={2}
                                    >
                                        Contact Details
                                    </Typography>
                                }
                                ref={telecomRef}
                                isEdit={true}
                                telecomArray={contactState?.telecom}
                                stateChangeActive={false}
                            />
                        </Grid>
                        {/* <Grid container item xs={8} spacing={2}>
              <Grid item sm={4}>
                <SelectWithTopLabelComponent
                  onChange={handleOnChange}
                  {...availableDaysValidationObject}
                />
              </Grid>
              <Grid item sm={4}>
                <SelectWithTopLabelComponent
                  onChange={handleOnChange}
                  {...availableTimingsValidationObject}
                />
              </Grid>
            </Grid> */}
                    </Grid>
                </Paper>
                <Paper
                    elevation={2}
                    sx={{ padding: '20px', marginBottom: '30px' }}
                >
                    {/* <Typography
                        sx={{ fontWeight: '500' }}
                        color={'primary'}
                        mb={2}
                    >
                        Contact Details
                    </Typography> */}
                    <Grid container>
                        <Grid container item xs={8}>
                            <FHIRAddress
                                customTitle={text => {
                                    return (
                                        <Typography
                                            sx={{ fontWeight: '500' }}
                                            color={'primary'}
                                            mb={2}
                                        >
                                            {text}
                                        </Typography>
                                    );
                                }}
                                ref={addressRef}
                                isEdit={true}
                                addressObject={currentAddressObject}
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </>
    );
});

export default FHIRContact;
